module.exports = __webpack_public_path__ + "img/logo-escondida.d58913e3.png";